/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rename_Save_FailedInputs */

const en_rename_save_failed = /** @type {(inputs: Rename_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The change could not be saved. Try again.`)
};

const de_rename_save_failed = /** @type {(inputs: Rename_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Änderung konnte nicht gespeichert werden. Versuche es erneut.`)
};

/**
* | output |
* | --- |
* | "The change could not be saved. Try again." |
*
* @param {Rename_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rename_save_failed = /** @type {((inputs?: Rename_Save_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rename_Save_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rename_save_failed(inputs)
	return en_rename_save_failed(inputs)
});